import Component from '../vendor/Component'

export default class DynamicTextReveal extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)

    this._wordElements = []
    this._originalTextContainer = this._elem.querySelector('[data-dynamic-text-reveal-original]')
    this._revealTextContainer = this._elem.querySelector('[data-dynamic-text-reveal-overlay]')

    this._isTicking = false
    this.onScroll = this.onScroll.bind(this)
    this.update = this.update.bind(this)
  }

  mount() {
    this.populateOverlayText()
    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  populateOverlayText() {
    const originalWords = this._originalTextContainer.innerText.trim()
    const originalWordsArray = originalWords.split(' ')
    let buildContent = ''

    originalWordsArray.forEach((word, index) => {
      buildContent += `<span class="sec-SplitText_BlockTitleWord">${word}</span>`

      if (index < originalWordsArray.length - 1) {
        buildContent += ' '
      }
    })

    this._revealTextContainer.innerHTML = buildContent
    this._wordElements = Array.from(this._revealTextContainer.querySelectorAll('.sec-SplitText_BlockTitleWord'))
  }

  onScroll() {
    if (!this._isTicking) {
      window.requestAnimationFrame(this.update)
      this._isTicking = true
    }
  }

  update() {
    const rect = this._elem.getBoundingClientRect()
    const vh = window.innerHeight
    const offsetFromTop = 100

    if (rect.top < vh && rect.bottom > 0) {
      const startTrigger = vh
      const endTrigger = offsetFromTop
      const totalTravelDistance = startTrigger - endTrigger - rect.height
      const distanceTraveled = startTrigger - rect.bottom

      const progress = distanceTraveled / totalTravelDistance
      this.revealTitle(progress)
    }

    this._isTicking = false
  }

  getOffsetTop (el) {
    const rect = el.getBoundingClientRect()
    return rect.top + (window.scrollY || window.pageYOffset)
  }


  revealTitle(progress) {
    if (!this._wordElements.length) return

    const clampedProgress = Math.max(0, Math.min(1, progress))

    if (clampedProgress === 0) {
      this._wordElements.forEach((wordEl) => {
        wordEl.style.setProperty('--Reveal_Amount', '0%')
      })
      return
    }

    if (clampedProgress === 1) {
      this._wordElements.forEach((wordEl) => {
        wordEl.style.setProperty('--Reveal_Amount', '100%')
      })
      return
    }

    this._wordElements.forEach((wordEl, index) => {
      const wordCount = this._wordElements.length
      const minimumPercent = index / wordCount
      const maximumPercent = (index + 1) / wordCount

      if (clampedProgress >= maximumPercent) {
        wordEl.style.setProperty('--Reveal_Amount', '100%')

      } else if (clampedProgress >= minimumPercent && clampedProgress < maximumPercent) {
        const wordProgress = (clampedProgress - minimumPercent) / (maximumPercent - minimumPercent)
        const wordProgressAmount = Math.round(wordProgress * 100 * 10) / 10
        wordEl.style.setProperty('--Reveal_Amount', `${wordProgressAmount}%`)

      } else {
        wordEl.style.setProperty('--Reveal_Amount', '0%')
      }
    })
  }
}
